import { render, staticRenderFns } from "./stepCoverImage.vue?vue&type=template&id=3cf762e4&scoped=true&"
import script from "./stepCoverImage.vue?vue&type=script&lang=js&"
export * from "./stepCoverImage.vue?vue&type=script&lang=js&"
import style0 from "./stepCoverImage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./stepCoverImage.vue?vue&type=style&index=1&id=3cf762e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf762e4",
  null
  
)

export default component.exports